import { Typography } from '@mui/material';
import { Column, Row, Spacer } from '../../../components';
import { t } from 'i18next';

interface DescriptionSectionProps {
  description: string;
  art: React.ReactNode;
  isMobile: boolean;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({ description, art, isMobile }) => {
  return (
    <Row style={{ alignItems: 'center' }}>
      <Column style={{ width: '100%' }}>
        <Typography color='secondary' variant='p18Bold'>
          {t('Description')}
        </Typography>
        <Spacer height='xxs' />
        <Typography color='secondary' variant='p16'>
          {t(description)}
        </Typography>
      </Column>
      {!isMobile && art}
    </Row>
  );
};

export default DescriptionSection;
